import { PaginationRequestInterface } from './pagination'
import FileFields from './FileFields'
import { GridSortRequest, GridSortModel } from './sort';
import { DateTime } from "luxon";
export default class RecRegistryBundleSnapshot {
  id = ""
  date = DateTime.local()
  containsSTCs = false
  containsLGCs = false
  file = new FileFields({})
  status = RecRegistryBundleSnapshotStatus.pending

  createdAt = DateTime.local()
  updatedAt = DateTime.local()

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(obj: any) {
    Object.assign(this, obj)
    this.date = DateTime.fromISO(obj.date)

    this.file = new FileFields(obj.file)
    this.createdAt = DateTime.fromISO(obj.createdAt)
    this.updatedAt = DateTime.fromISO(obj.updatedAt)
  }

  get downloadLink(): string {
    return `/api/rec-registry/bundle-snapshots/${this.id}/download`
  }
}

export enum RecRegistryBundleSnapshotStatus {
  pending = "pending",
  created = "created",
  archived = "archived",
}

// Request

export class RecRegistryBundleSnapshotRequest implements PaginationRequestInterface, GridSortRequest {
  sort?: GridSortModel
  sortDesc?: boolean
  per = 25
  page = 0

  static copy(from: RecRegistryBundleSnapshotRequest): RecRegistryBundleSnapshotRequest {
    const newRequest = new RecRegistryBundleSnapshotRequest()
    Object.assign(newRequest, from)
    return newRequest
  }

  get path(): string {
    return `/rec-registry/bundle-snapshots`
  }
}